module.exports = __webpack_public_path__ + "media/images/brand/OGP-f954a30f9afef75cfa00969a8798c784.png";